
import _ from "lodash";
import { saveAs } from "file-saver";
import { domToBlob, domToCanvas } from "modern-screenshot";

export default {
    name: "avatar_creator",
    props: ["isOpenAvatarCreator", "currentPoints", "source", "jukeboxBackgrounds", "week", "isReleaseDlc"],
    data(){
        return {
            layers: ["background", "avatar", "face_paint", "glasses", "headphones", "hat", "instrument", "microphone"],
            myAvatar: {},
            defaultAvatar: {
                background: 0,
                avatar: 1,
                color: 1,
                face_paint: 0,
                glasses: 0,
                headphones: 0,
                hat: 0,
                instrument: 0,
                microphone: 0
            },
            avatarColorsMap: {
                1: ["#FF0000", "#996EFF", "#FF62E0", "#FF8C00"],
                2: ["#1E7B4B", "#AE00FF", "#9E4306", "#F13D73"],
                3: ["#C88D5A", "#C48FA8", "#7994D6", "#FBB03B"],
                4: ["#D10D16", "#0C65D0", "#CD750D", "#8B0FC8"],
                5: ["#77797F", "#FF6EC3", "#FCC454", "#4DAAF8"],
                6: ["#E28A40", "#E3565F", "#9685B3", "#61B6C1"],
                7: ["#C6C9C9", "#EB9F57", "#B6629C", "#009383"],
            },
            selectedFeature: "avatar",
            leftFeatures: ["avatar", "instrument", "glasses", "microphone"],
            rightFeatures: ["hat", "headphones", "face_paint", "background"],
            elements: {
                avatar: [1, 1, 1, 1, 1, 1, 1],
                instrument: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
                glasses: [1, 1, 1, 1, 1],
                microphone: [1, 1, 1, 1, 1],
                hat: [1, 1, 1, 1, 1, 1, 1, 1],
                headphones: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
                face_paint: [1, 1, 1, 1, 1],
                background: [1, 1, 1, 1, 1, 1, 1],
            },
            backgroundFrameCounts: [146, 146, 146, 146, 146, 146, 146, 122, 146, 151, 141, 146, 153, 499, 150, 204, 150, 141, 150, 150, 150, 150, 150],
            backgroundFrameDelay: 33.29,
            isLoading: true, isSaving: false, isDownloading: false,
            isShowIntroPopup: false, isSkipCustomize: false, isShowSchedulePopup: false,
            uploadImg: null, downloadImg: null,
            gifJsUrl: "https://cdnjs.cloudflare.com/ajax/libs/gif.js/0.2.0/gif.js",
            gifWorkerUrl: "https://cdnjs.cloudflare.com/ajax/libs/gif.js/0.2.0/gif.worker.js",
            _gifWorkerBlobUrl: null,
            _frameSequenceCache: {},
            progressPercent: 0,
        }
    },
    computed: {
        isFirstAvatar(){ return !this.user || !this.user.avatar; },
        allFeatures(){ return [...this.leftFeatures, ...this.rightFeatures]; },
        availableBackgrounds() {
            const defaults = [1, 2, 3];
            const won = (this.jukeboxBackgrounds || [])
                .filter(n => n > 0)
                .map(n => n + 3);
            const extras = Array.from({ length: 14 }, (_, i) => i + 10);
            return [...defaults, ...won, ...extras];
        },
        
    },
    watch: {
        jukeboxBackgrounds(newVal, oldVal) {
            if (!Array.isArray(newVal) || !Array.isArray(oldVal)) return;
            const oldSet = new Set(oldVal);
            const newBackgrounds = newVal.filter(n => !oldSet.has(n));
            if (!newBackgrounds.length) return;

            const queue = new createjs.LoadQueue();
            newBackgrounds.forEach(n => {
                const index = n + 3;
                queue.loadFile(this.formattedAssetUrl(`/static/images/avatar/selection/background/${index}.png`));
                queue.loadFile(this.formattedAssetUrl(`/static/images/avatar/layer/background/${index}.gif`));
            });
        }
    },
    created(){
        this._frameSequenceCache = {};
        this.myAvatar = this.isFirstAvatar? { ...this.defaultAvatar } : { ...this.defaultAvatar, ...JSON.parse(this.user.avatar) };
    },
    mounted(){
        if(!this.user?.avatar) this.isShowIntroPopup = true;

        const preloadQueue = new createjs.LoadQueue();

        this.layers.forEach(layer => {
            let indices;
            if (layer === "background" && this.jukeboxBackgrounds !== undefined) {
                indices = this.availableBackgrounds;
            } else {
                const elementsCount = this.elements[layer] ? this.elements[layer].length : 0;
                indices = Array.from({ length: elementsCount }, (_, i) => i + 1);
            }

            indices.forEach(index => {
                preloadQueue.loadFile(this.formattedAssetUrl(`/static/images/avatar/selection/${layer}/${index}.png`));

                if(layer === "avatar") {
                    for (let colorIndex = 1; colorIndex <= 4; colorIndex++) {
                        preloadQueue.loadFile(this.formattedAssetUrl(`/static/images/avatar/layer/${layer}/${index}_${colorIndex}.png`));
                    }
                } else if(layer === "background") {
                    preloadQueue.loadFile(this.formattedAssetUrl(`/static/images/avatar/layer/${layer}/${index}.gif`));
                } else {
                    preloadQueue.loadFile(this.formattedAssetUrl(`/static/images/avatar/layer/${layer}/${index}.png`));
                }
            });
        });

        preloadQueue.addEventListener("fileload", this.onFinishPreloadImages);
        window.addEventListener("resize", this.onHandleWindowResize);

        setTimeout(() => { this.isLoading = false; }, 3000);
    },
    beforeDestroy(){
        window.removeEventListener("resize", this.onHandleWindowResize);
        if (this.uploadImg?.url) URL.revokeObjectURL(this.uploadImg.url);
        if (this.downloadImg?.url) URL.revokeObjectURL(this.downloadImg.url);
        if (this._gifWorkerBlobUrl) URL.revokeObjectURL(this._gifWorkerBlobUrl);
    },
    methods: {
        onFinishPreloadImages(){ this.isLoading = false; this.onHandleWindowResize(); },
        onHandleWindowResize(){ const $win = $(window); },
        showExtraContent(index){
            console.log(this.isReleaseDlc)
            if(!this.isReleaseDlc){
                switch(this.selectedFeature){
                    case "avatar": 
                    case "face_paint":
                    case "instrument":
                    case "hat":
                    case "glasses":
                        return index > (this.elements[this.selectedFeature].length - 2)
                }
            }
            else{
                return false;
            }
        },

        getFeatureIconStyle(feature) {
            const url = this.formattedAssetUrl(`/static/images/avatar/feature/${feature}.svg`);
            return {
                WebkitMaskImage: `url(${url})`,
                maskImage: `url(${url})`,
                WebkitMaskSize: "160%",
                maskSize: "160%",
                WebkitMaskRepeat: "no-repeat",
                maskRepeat: "no-repeat",
                WebkitMaskPosition: "center",
                maskPosition: "center",
            };
        },

        getLayerImage(element, index){
            if (element === "avatar") {
                const colorIndex = this.myAvatar.color || 1;
                return this.formattedAssetUrl(`/static/images/avatar/layer/${ element }/${ index }_${ colorIndex }.png`);
            }
            if (element === "background") {
                return this.formattedAssetUrl(`/static/images/avatar/layer/${ element }/${ index }.gif`);
            }
            return this.formattedAssetUrl(`/static/images/avatar/layer/${ element }/${ index }.png`);
        },

        onSelectElement(feature, index){
            if(this.isDownloading || this.isSaving) return;
            if (feature === "avatar" && !this.isReleaseDlc && index > (this.elements.avatar.length - 2)) return;
            if (feature === "background" && !this.isReleaseDlc && index > 9) return;
            this.uploadImg = null;
            this.downloadImg = null;

            let updatedAvatar = {
                ...this.myAvatar,
                [feature]: index,
            };

            if (feature === "avatar") {
                updatedAvatar.color = 1;
            }

            this.myAvatar = updatedAvatar;
        },

        onSelectColor(colorIndex) {
            if(this.isDownloading || this.isSaving) return;
            this.uploadImg = null;
            this.downloadImg = null;

            this.myAvatar = {
                ...this.myAvatar,
                color: colorIndex
            };
        },

        loadScript(src) {
            return new Promise((resolve, reject) => {
                const script = document.createElement("script");
                script.src = src;
                script.onload = resolve;
                script.onerror = () => reject(new Error(`Failed to load script: ${src}`));
                document.head.appendChild(script);
            });
        },

        async getGifWorkerBlobUrl() {
            if (this._gifWorkerBlobUrl) return this._gifWorkerBlobUrl;
            const res = await fetch(this.gifWorkerUrl);
            if (!res.ok) throw new Error("Failed to fetch gif.worker.js");
            const text = await res.text();
            const blob = new Blob([text], { type: "application/javascript" });
            this._gifWorkerBlobUrl = URL.createObjectURL(blob);
            return this._gifWorkerBlobUrl;
        },

        loadImage(src) {
            return new Promise((resolve, reject) => {
                const img = new Image();
                img.crossOrigin = "anonymous";
                img.onload = () => resolve(img);
                img.onerror = () => reject(new Error(`Failed to load frame image: ${src}`));
                img.src = src;
            });
        },

        async loadFrameSequence(bgIndex) {
            if (this._frameSequenceCache[bgIndex]) {
                return this._frameSequenceCache[bgIndex];
            }

            const imagePromises = [];
            for (let i = 0; i < this.backgroundFrameCounts[bgIndex]; i++) {
                const src = this.formattedAssetUrl(`/static/images/avatar/layer/background/${bgIndex + 1}/${i}.png`);
                imagePromises.push(this.loadImage(src));
            }

            const images = await Promise.all(imagePromises);
            const frames = images.map(img => ({ image: img, delay: this.backgroundFrameDelay }));

            this._frameSequenceCache[bgIndex] = frames;
            return frames;
        },

        drawCover(destCtx, srcImage, destW, destH) {
            const srcW = srcImage.naturalWidth || srcImage.width;
            const srcH = srcImage.naturalHeight || srcImage.height;
            const srcRatio = srcW / srcH;
            const destRatio = destW / destH;

            let drawW, drawH, offsetX, offsetY;
            if (srcRatio > destRatio) {
                drawH = destH;
                drawW = destH * srcRatio;
                offsetX = (destW - drawW) / 2;
                offsetY = 0;
            } else {
                drawW = destW;
                drawH = destW / srcRatio;
                offsetX = 0;
                offsetY = (destH - drawH) / 2;
            }
            destCtx.drawImage(srcImage, offsetX, offsetY, drawW, drawH);
        },

        async captureTransparentOverlay(node) {
            const width = node.offsetWidth;
            const height = node.offsetHeight;

            const bgImgEl = node.querySelector("img[src*='/avatar/layer/background/']");
            const prevDisplay = bgImgEl ? bgImgEl.style.display : null;
            if (bgImgEl) bgImgEl.style.display = "none";

            const bgWhiteEl = node.querySelector(".bg-white");
            const prevBgColor = bgWhiteEl ? bgWhiteEl.style.backgroundColor : null;
            if (bgWhiteEl) bgWhiteEl.style.backgroundColor = "transparent";

            let canvas;
            try {
                canvas = await domToCanvas(node, {
                    width,
                    height,
                    backgroundColor: null,
                });
            } finally {
                if (bgImgEl) bgImgEl.style.display = prevDisplay || "";
                if (bgWhiteEl) bgWhiteEl.style.backgroundColor = prevBgColor || "";
            }

            return { canvas, width, height };
        },

        async generateAnimatedGif(node) {
            if (typeof window.GIF === "undefined") {
                await this.loadScript(this.gifJsUrl);
            }
            const workerScript = await this.getGifWorkerBlobUrl();

            const { canvas: staticLayerCanvas, width, height } = await this.captureTransparentOverlay(node);

            const bgIndex = this.myAvatar.background - 1;
            const frames = await this.loadFrameSequence(bgIndex);

            return new Promise((resolve, reject) => {
                try {
                    const gif = new window.GIF({
                        workers: 2,
                        quality: 10,
                        width,
                        height,
                        workerScript,
                    });

                    gif.on("progress", (p) => {
                        this.progressPercent = Math.round(p * 100);
                    });

                    gif.on("finished", (blob) => {
                        this.progressPercent = 100;
                        resolve(blob)
                    });
                    gif.on("abort", () => reject(new Error("GIF rendering aborted")));

                    frames.forEach(frame => {
                        const composeCanvas = document.createElement("canvas");
                        composeCanvas.width = width;
                        composeCanvas.height = height;
                        const ctx = composeCanvas.getContext("2d");

                        this.drawCover(ctx, frame.image, width, height);
                        ctx.drawImage(staticLayerCanvas, 0, 0, width, height);

                        gif.addFrame(composeCanvas, { delay: frame.delay, copy: true });
                    });

                    gif.render();
                } catch (err) {
                    reject(err);
                }
            });
        },

        onUploadAvatar(blob){
            const tokenHeader = {
                headers: {
                    authorization: `Bearer ${ this.user?.token }`,
                    "Content-Type": "multipart/form-data"
                }
            };

            let newData = new FormData();
            newData.append("avatar", JSON.stringify(this.myAvatar));
            newData.append("image_file", blob);

            this.$axios.$post("/auth/update_avatar", newData, this.tokenHeader).then(res => {
                this.isSaving = false;
                this.isSkipCustomize = false;
                this.$store.commit("auth/updateUser", res.item);
                if(res.stamp) this.$store.commit("stamp/addItem", res.stamp);

                if(this.source == "component"){
                    this.$emit("update:isOpenAvatarCreator", false);
                }else if(this.source == "page"){
                    this.isShowSchedulePopup = true;
                }
            }).catch(err => {
                this.isSaving = false;
                return this.onHandleApiError(err);
            });
        },

        async onGenerateImage(type){
            this.progressPercent = 0;
            const node = document.getElementById(`final_${ type }_avatar`);
            const hasAnimatedBg = this.myAvatar.background > 0;

            try {
                let blob;

                if (type === "upload") {
                    blob = await domToBlob(node);
                } else {
                    if (hasAnimatedBg) {
                        blob = await this.generateAnimatedGif(node);
                    } else {
                        blob = await domToBlob(node);
                    }
                }

                if (type === "upload") {
                    if (this.uploadImg?.url) URL.revokeObjectURL(this.uploadImg.url);
                    this.uploadImg = { blob, url: URL.createObjectURL(blob) };
                    this.onUploadAvatar(blob);
                } else {
                    if (this.downloadImg?.url) URL.revokeObjectURL(this.downloadImg.url);
                    this.downloadImg = { blob, url: URL.createObjectURL(blob) };
                    const fileName = hasAnimatedBg ? "My Avatar.gif" : "My Avatar.png";

                    saveAs(blob, fileName);
                    this.isDownloading = false;
                    this.progressPercent = 0;
                    this.onSubmitDownloadStamp(hasAnimatedBg);
                }
            } catch (err) {
                console.error("Generate image failed:", err);
                this.isDownloading = false;
                this.isSaving = false;
                this.progressPercent = 0;
            }
        },

        onSubmitDownloadStamp(isGif){
            if(!isGif) return;

            this.$store.dispatch("stamp/onSubmitStamp", {
                title: `Download Avatar`,
                room: "Entrance"
            });
        },

        onClickUploadBtn(item){
            if (this.isSaving || this.isDownloading) return;
            this.isSaving = true;
            this.progressPercent = 0;
            this.onHandleTriggerAnalytics("update@avatar");

            if(this.isSkipCustomize){
                this.uploadImg = null;
                this.myAvatar = { ...this.defaultAvatar };
            }

            if(this.uploadImg){
                this.onUploadAvatar(this.uploadImg.blob);
            }else{
                this.onGenerateImage("upload");
            }
        },

        onClickDownloadBtn(){
            if (this.isDownloading || this.isSaving) return;
            this.isDownloading = true;
            this.progressPercent = 0;
            this.onHandleTriggerAnalytics("download@avatar");

            if(this.downloadImg){
                const isGif = this.myAvatar.background > 0;
                const fileName = isGif ? "My Avatar.gif" : "My Avatar.png";

                saveAs(this.downloadImg.blob, fileName);
                this.isDownloading = false;
                this.progressPercent = 0;
                this.onSubmitDownloadStamp(isGif);
            }else{
                this.onGenerateImage("download");
            }
        },
        onClickCloseBtn(){
            this.myAvatar = this.isFirstAvatar? { ...this.defaultAvatar } : { ...this.defaultAvatar, ...JSON.parse(this.user.avatar) };
            this.downloadImg = null;
            this.uploadImg = null;

            this.$emit("update:isOpenAvatarCreator", false);
            this.onHandleTriggerAnalytics("close@avatar");
        },
    }
}
